import './BetbookLinkBox.less';
import React from 'react';
import NuiBox from 'nike-ui/src/components/nui-box/NuiBox';
import RouteLink from 'nike-ui/src/common/routing/RouteLink';

const BetbookLinkBox = ({ title, route, params, searchParams, beforeNavigate, icon, ...other }) => {
    return (
        <RouteLink route={route} params={params} searchParams={searchParams} beforeNavigate={beforeNavigate}>
            <NuiBox oldStyle otherClass="flex py-15 mb-15 betbook-link-box" {...other}>
                <span className="flex items-center">{icon}</span>
                <span className="flex items-center betbook-link-box-title c-black-100 fs-18">{title}</span>
            </NuiBox>
        </RouteLink>
    );
};

export default BetbookLinkBox;
